import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-2" }

import { computed, onMounted, ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import MultipleCharts from '@/components/SmartLink/charts/MultipleCharts.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/******************************** 
 ********** CONSTANTES ********** 
 *******************************/ 
import { LABELS, STRING_GENERAL } from '@/constants/labels'; 

/******************************** 
 ************ I18N ************** 
 *******************************/ 
import { useI18n }      from 'vue-i18n'; 
import { useStore }         from 'vuex';
import { getLatencyHistoryReport, getOperabilityHistoryReport, 
getSensoresHistoryReport, getBandWidthDataHistoryReport } from '@/services/RAOS/Report';
import { getAllPerforadorasData } from '@/services/RAOS/Admin';


/**
 * Fecha seleccionada para generar el reporte
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ReportView',
  setup(__props) {

const { t }  = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store         = useStore();

/********************************
 *********** SERVICES ***********
 *******************************/
const dateSelected = ref()

/**
 * Horario seleccionado para generar el reporte
 */
const horarioSelected = ref(0)

/**
 * Lista de horarios
 */
const horarioList = ref([
    {title: '1 Dia', value: 0 },
    {title: 'Diurno', value: 1 },
    {title: 'Nocturno', value: 2 },
])

/**
 * Equipos seleccionados para generar el reporte
 */
const equiposSelected = ref()

/**
 * Lista de equipos disponibles (Equipos Perforadoras) para generar el reporte
 */
const equiposList = ref<any>([])


/**
 * Obtiene la lista de perforadoras desde la API (getAllPerforadorasData)
 */
async function getPerforadorasData(){
    const allData = await getAllPerforadorasData()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        if(allData.data.length > 0) {
            allData.data.forEach((item: any) => {
                const objClient = {
                    title: `${item.tag} - ${item.ip}`,
                    value: item.ip
                }
                equiposList.value.push(objClient);
            })
        }

    }
}



/**
 * Muestra el gráfico de latencia si hay datos
 */
const showGraphLatencia = ref(false)

/**
 * Información final para los gráficos de Latencia
 */
const finalLatencyInfo = ref<any>({
    allData : [],
    allName : [],
})

/**
 * Obtiene el datos de latencia para el reporte desde la API (getLatencyHistoryReport)
 * @param params 
 */
async function getLatencyReport(params:any) {
    const allDataLatencia = await getLatencyHistoryReport(params)

    if( allDataLatencia.status === 400 ){
        showGraphLatencia.value = false;
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataLatencia.status === 200 ){
        if(allDataLatencia.data.length > 0) {
            
            const grouped = allDataLatencia.data.reduce((acc: Record<string, number[][]>, item: any) => {

                const tiempo = new Date(item.fecha ?? '');
                const milliseconds = tiempo.getTime();

                const ip = item.ip ? item.ip : '000.000.000.000';

                if (!acc[ip]) {
                    acc[ip] = []; // Puedes cambiar "ip" por "name" si prefieres
                }
                acc[ip].push([milliseconds, item.latencia])
                return acc;
            }, {});

            const allData = Object.values(grouped);
            const allName = Object.keys(grouped)

            finalLatencyInfo.value = {
                allData,
                allName
            }
        }
        else{
            showGraphLatencia.value = false;
        }
    }
}



/**
 * Muestra el gráfico de Sensores si hay datos
 */
const showGraphSensores = ref(false)

/**
 * Información final para los gráficos de Temperatura
 */
const finalTemperaturaInfo = ref<any>({
    allData : [],
    allName : [],
})

/**
 * Información final para los gráficos de Voltaje
 */
const finalVoltajeInfo = ref<any>({
    allData : [],
    allName : [],
})

/**
 * Obtiene los datos de los sensores para el reporte desde la API (getSensoresHistoryReport)
 * separándolos en temperatura y voltaje
 * @param params 
 */
async function getSensoresReport(params:any) {
    const allDataSensores = await getSensoresHistoryReport(params)

    if( allDataSensores.status === 400 ){
        showGraphSensores.value = false;
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataSensores.status === 200 ){
        if(allDataSensores.data.length > 0){

            const grouped = allDataSensores.data.reduce((acc: Record<any,any>, item: any) => {

                const tiempo = new Date(item.fecha ?? '');
                const milliseconds = tiempo.getTime();

                const ip = item.ip ? item.ip : '000.000.000.000';

                if(!acc.temperatura){
                    acc.temperatura = {}
                }

                if (!acc.temperatura[ip]) {
                    acc.temperatura[ip] = []; // Puedes cambiar "ip" por "name" si prefieres
                }

                if(!acc.voltaje){
                    acc.voltaje = {}
                }

                if (!acc.voltaje[ip]) {
                    acc.voltaje[ip] = []; // Puedes cambiar "ip" por "name" si prefieres
                }

                const valores = JSON.parse(item.valores ?? '')

                const tempvalues = (valores.temperature[0] ?? 0) / 100;
                const voltvalues = (valores.voltage[0] ?? 0) / 100;

                acc.temperatura[ip].push([milliseconds, tempvalues])
                acc.voltaje[ip].push([milliseconds, voltvalues])
                return acc;
            }, {});

            const allDataTemperatura = Object.values(grouped.temperatura);
            const allNameTemperatura = Object.keys(grouped.temperatura)
            const allDataVoltaje = Object.values(grouped.voltaje);
            const allNameVoltaje = Object.keys(grouped.voltaje)

            finalTemperaturaInfo.value = {
                allData: allDataTemperatura,
                allName: allNameTemperatura
            }
            finalVoltajeInfo.value = {
                allData: allDataVoltaje,
                allName: allNameVoltaje
            }
        }
        else{
            showGraphSensores.value = false;
        }
    }
}




/**
 * Muestra la Tabla de Operabilidad si hay datos
 */
const showTableOperability = ref(false)

/**
 * Headers de la tabla de operabilidad
 */
const headers = computed(() =>  [
    { title: 'IP', key: 'ip'},
    { title: t('labels.name'), key: 'name'},
    { title: t('labels.uptime'), key: 'uptime'},
    { title: t('labels.loss'), key: 'lost'},
])

/**
 * Items de la tabla de operabilidad
 */
const tableItems = ref<any>([])

/**
 * Obtiene el reporte de operabilidad para la tabla de reporte desde la API (getOperabilityHistoryReport)
 * @param params 
 */
async function getOperabilityReport(params:any){

    const allDataOperability = await getOperabilityHistoryReport(params)

    if( allDataOperability.status === 400 ){
        showTableOperability.value = false;
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataOperability.status === 200 ){
        if(allDataOperability.data.length > 0) {
            showTableOperability.value = true;
            allDataOperability.data.forEach((item:any) => {
                
                const totalUptime = item.ok + item.alert + item.alarm + item.down;
                const uptime = `${(((item.ok + item.alert + item.alarm) / totalUptime)*100).toFixed(2)}%`;

                const NotDown = item.ok + item.alert + item.alarm ;
                const lost = `${((item.down / NotDown)*100).toFixed(2)}%`


                tableItems.value.push({
                    ip: item.ip,
                    name: item.name,
                    uptime : uptime,
                    lost : lost
                })

            })
        }
        else{
            showTableOperability.value = false;
        }
    }
}


/**
 * Muestra el gráfico de Ancho de Banda si hay datos
 */
const showGraphBandWidth = ref(false)

/**
 * Información final para los gráficos de Ancho de banda
 */
const finalBandWidthInfo = ref<any>({
    allData : [],
    allName : [],
})



/**
 * Obtiene el datos de ancho de banda para el reporte desde la API (getBandWidthHistoryReport)
 * @param params 
 */
async function getBandWidthHistoryReport(params:any){

    const allDataBanWidth = await getBandWidthDataHistoryReport(params)

    if( allDataBanWidth.status === 400 ){
        showGraphBandWidth.value = false;
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataBanWidth.status === 200 ){
        if(allDataBanWidth.data.length > 0) {
            const grouped = allDataBanWidth.data.reduce((acc: Record<any,any>, item: any) => {

                const tiempo = new Date(item.fecha ?? '');
                const milliseconds = tiempo.getTime();

                const ip = item.ip ? item.ip : '000.000.000.000';

                if(!acc.bandwidth){
                    acc.bandwidth = {}
                }

                if (!acc.bandwidth[ip]) {
                    acc.bandwidth[ip] = []; 
                }

                const anchoDeBanda = JSON.parse(item.bandwidth ?? '{"Tx" : -1, "Rx" : -1}')

                const bandwidthValues = anchoDeBanda.Tx ?? 0;

                acc.bandwidth[ip].push([milliseconds, bandwidthValues])
                return acc;
            }, {});

            const allDataBandWidth = Object.values(grouped.bandwidth);
            const allNameBandWidth = Object.keys(grouped.bandwidth)

            finalBandWidthInfo.value = {
                allData: allDataBandWidth,
                allName: allNameBandWidth
            }
            showGraphBandWidth.value = true;
        }
        else{
            showGraphBandWidth.value = false;
        }
    }
}


/**
 * Captura todos los parámetros seleccionados
 * y ejecuta las funciones para obtener los reportes
 */
async function getAllInfoReport() {
    const params = {
        fecha : dateSelected.value,
        turno : horarioSelected.value,
        ips : equiposSelected.value
    }
    showGraphLatencia.value = true;
    showGraphSensores.value = true;
    showTableOperability.value = true;
    showGraphBandWidth.value = true;
    finalLatencyInfo.value.allData = []
    finalLatencyInfo.value.allName = []
    finalTemperaturaInfo.value.allData = []
    finalTemperaturaInfo.value.allName = []
    finalVoltajeInfo.value.allData = []
    finalVoltajeInfo.value.allName = []
    finalBandWidthInfo.value.allData = []
    finalBandWidthInfo.value.allName = []
    tableItems.value = []
    
    getOperabilityReport(params)
    getLatencyReport(params)
    getSensoresReport(params)    
    getBandWidthHistoryReport(params)    
}



onMounted(async () => {
  await getPerforadorasData() 
})


return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "ma-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "3",
          class: "pa-0 pr-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref(t)('labels.date')), 1),
            _createVNode(_component_VueDatePicker, {
              class: "mb-4",
              modelValue: dateSelected.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateSelected).value = $event)),
              "model-type": _unref(STRING_GENERAL).timeRAOS,
              format: _unref(STRING_GENERAL).timeRAOS
            }, null, 8, ["modelValue", "model-type", "format"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "3",
          class: "pa-0 pr-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(t)('labels.timetable')), 1),
            _createVNode(_component_v_select, {
              modelValue: horarioSelected.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((horarioSelected).value = $event)),
              items: horarioList.value,
              density: "compact",
              variant: "outlined",
              "item-title": "title",
              "item-value": "value",
              "hide-details": ""
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "3",
          class: "pa-0 pr-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)('labels.equipment')), 1),
            _createVNode(_component_v_select, {
              modelValue: equiposSelected.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((equiposSelected).value = $event)),
              items: equiposList.value,
              density: "compact",
              variant: "outlined",
              "item-title": "title",
              "item-value": "value",
              multiple: "",
              chips: "",
              "hide-details": ""
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "3",
          class: "pa-0 pt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: getAllInfoReport,
              block: "",
              color: "success",
              disabled: dateSelected.value==='' || dateSelected.value === undefined
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.send')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { clas: "ma-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (showTableOperability.value)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  class: "ma-4 pa-4",
                  color: "transparent"
                }, {
                  default: _withCtx(() => [
                    (tableItems.value.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_data_table, {
                          key: 0,
                          headers: headers.value,
                          items: tableItems.value,
                          class: "text-caption allTable",
                          density: "compact",
                          "item-value": "name",
                          "hide-default-footer": "",
                          hover: ""
                        }, null, 8, ["headers", "items"]))
                      : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "ma-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "6",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (showGraphLatencia.value)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  color: "transparent",
                  class: "ma-4 text-center",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    (finalLatencyInfo.value.allData.length > 0)
                      ? (_openBlock(), _createBlock(MultipleCharts, {
                          key: 0,
                          "array-items": finalLatencyInfo.value.allData,
                          "array-names": finalLatencyInfo.value.allName,
                          title: _unref(t)('labels.latency')
                        }, null, 8, ["array-items", "array-names", "title"]))
                      : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (showGraphSensores.value)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  color: "transparent",
                  class: "ma-4 text-center",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    (finalTemperaturaInfo.value.allData.length > 0)
                      ? (_openBlock(), _createBlock(MultipleCharts, {
                          key: 0,
                          "array-items": finalTemperaturaInfo.value.allData,
                          "array-names": finalTemperaturaInfo.value.allName,
                          title: _unref(t)('labels.temperature')
                        }, null, 8, ["array-items", "array-names", "title"]))
                      : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (showGraphSensores.value)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  color: "transparent",
                  class: "ma-4 text-center",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    (finalVoltajeInfo.value.allData.length > 0)
                      ? (_openBlock(), _createBlock(MultipleCharts, {
                          key: 0,
                          "array-items": finalVoltajeInfo.value.allData,
                          "array-names": finalVoltajeInfo.value.allName,
                          title: _unref(t)('labels.voltage')
                        }, null, 8, ["array-items", "array-names", "title"]))
                      : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (showGraphBandWidth.value)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  color: "transparent",
                  class: "ma-4 text-center",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    (finalBandWidthInfo.value.allData.length > 0)
                      ? (_openBlock(), _createBlock(MultipleCharts, {
                          key: 0,
                          "array-items": finalBandWidthInfo.value.allData,
                          "array-names": finalBandWidthInfo.value.allName,
                          title: _unref(t)('labels.bandwidth')
                        }, null, 8, ["array-items", "array-names", "title"]))
                      : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})